module.exports = __webpack_public_path__ + "img/0Q3A4226_L_Wood_MockedUp.74986ec9.jpg";